<template>
    <div class="order-detail">
        <div class="flex__column header">
            <span class="fs_40 c_ff lh_50">{{orders.status_name}}</span>
            <span class="fs_28 c_ff lh_40">订单编号：{{orders.order_number}}</span>
        </div>
        <!-- 地址信息 -->
        <div class="flex__column address" v-if="orders.deliver_type==1">
            <span class="fs_34 c_1a lh_50">{{orders.linkman}}&emsp;{{orders.mobile_phone}}</span>
            <span class="fs_28 c_66 lh_40">{{orders.province}}{{orders.city}}{{orders.area}}{{orders.address}}</span>
        </div>
        <div class="flex__between__center address" v-else>
            <div class="flex__column">
                <span class="fs_34 c_1a lh_50">{{orders.store_name}}</span>
                <span class="fs_28 c_66 lh_40">{{orders.store_address}}</span>
            </div>
            <span class="jcicon jcicon-daohang1 fs_40 c_main"></span>
        </div>
        <!-- 商品列表 -->
        <div class="sale-box">
            <div class="flex sale__item" v-for="(item,index) in orders.order_product" :key="index">
                <div class="img-box">
                    <img :src="item.product_cover_img" alt="">
                    <div class="tips">
                        <span class="fs_22 c_ff" v-if="item.product_type==1">实物</span>
                        <span class="fs_22 c_ff" v-else>虚拟</span>
                    </div>
                </div>
                <div class="flex__null__around sale__item__right">
                    <span class="fs_26 c_1a lh_36 ellipsis_two">{{item.product_name}}</span>
                    <span class="fs_26 c_80">x{{item.number}}</span>
                    <div class="mt_10 lh_40">
                        <span class="fs_30 c_main" v-if="item.product_integral">{{item.product_integral}}<span class="fs_24">积分</span></span>
                        <span class="fs_24 c_main" v-if="item.product_integral&&item.product_money!='0.00'">+</span>
                        <span class="fs_28 c_main" v-if="item.product_money!='0.00'">{{item.product_money}}<span class="fs_24">元</span></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 支付信息-->
        <div class="info-box">
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">实付款</span>
                <div class="mt_10 lh_40">
                    <span class="fs_30 c_main" v-if="orders.pay_integral">{{orders.pay_integral}}<span class="fs_24">积分</span></span>
                    <span class="fs_24 c_main" v-if="orders.pay_integral&&orders.pay_money!='0.00'">+</span>
                    <span class="fs_28 c_main" v-if="orders.pay_money!='0.00'">{{orders.pay_money}}<span class="fs_24">元</span></span>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">到货方式</span>
                <span class="fs_26 c_4d">{{convert[orders.deliver_type]}}</span>
            </div>
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">备注</span>
                <span class="fs_26 c_4d" v-if="orders.remark">{{orders.remark}}</span>
                <span class="fs_26 c_4d" v-else>暂无</span>
            </div>
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">下单时间</span>
                <span class="fs_26 c_4d">{{orders.order_time}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.pay_time">
                <span class="fs_26 c_80">付款时间</span>
                <span class="fs_26 c_4d">{{orders.pay_time}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.express_time">
                <span class="fs_26 c_80">发货时间</span>
                <span class="fs_26 c_4d">{{orders.express_time}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.confirm_time">
                <span class="fs_26 c_80">收货时间</span>
                <span class="fs_26 c_4d">{{orders.confirm_time}}</span>
            </div>
        </div>
        <!-- 底部操作 -->
        <div class="flex__end__center footer" v-if="orders.status!=6">
            <button class="hollow-btn" v-if="orders.status==1" @click="cancel(orders.id)">取消订单</button>
            <button class="hollow-btn" v-if="orders.status==4||orders.status==5||orders.status==7||orders.status==8" @click="del(orders.id)">删除订单</button>
            <button class="hollow-btn" v-if="(orders.status==3||orders.status==4||orders.status==5)&&orders.deliver_type==1" @click="setLogistics(orders.id)">查看物流</button>
            <button class="solid-btn" v-if="orders.status==3" @click="harvest(orders.id)">确认收货</button>
            <button class="solid-btn" v-if="orders.status==1" @click="pay(orders.id)">支付</button>
            <button class="solid-btn" v-if="orders.status==2" @click="remind(orders.id)">提醒发货</button>
        </div>
    </div>
</template>
<script>
export default {
    name: "IntegralOrderDetail",
    data(){
        return{
            convert:{1: '邮寄', 2: '自提'},
            refresh: false,
            orders:{
                order_product:[]
            }
        }
    },
    methods:{
          // 提醒发货
        remind(id){
            this.axios.post('/wechat.php/Integral/orderRemind',{
                user_id: localStorage.user_id,
                order_id: id
            }).then(
                res=>{
                    this.$dialog.alert({
                        message: res.data.message
                    })
                }
            )
        },
        // 取消订单
        cancel(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认取消该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Integral/orderCancel',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 删除订单
        del(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认删除该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Integral/orderDelete',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                ) 
            }).catch(()=>{})
        },
        // 查看物流
        setLogistics(id){
            this.$store.commit('setLogistics','/wechat.php/Integral/getExpressData');
            this.$router.push('/Mall/Logistics/'+id);
        },
        // 确认收货
        harvest(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认收货？'
            }).then(() => {
                this.axios.post('/wechat.php/Integral/orderConfirm',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 支付
        pay(id){
            this.axios.post('/wechat.php/Integral/orderPay',{
                user_id:localStorage.user_id,
                order_id:id,
            }).then(
                res=>{
                    if(res.data.code==1){
                        let pay={};
                        pay.pay_parameters=res.data.data.pay_parameters;
                        pay.back_link='/Integral/Record';
                        this.$store.commit('setPay',pay);
                        this.$router.push('/Pay');
                    }else{
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                }
            )
        }          
    },
    mounted(){
        this.axios.post('/wechat.php/Integral/getOrderDetailData',{
            user_id: localStorage.user_id,
            order_id: this.$route.params.id
        }).then(
            res=>{
                this.orders=res.data.data.order;
            }
        )
    }
}
</script>
<style scoped>
.header{
    padding: 20px 30px;
    background: #F93A42;
}
.address{
    padding: 30px;
    background: #fff;
}
.sale-box{
    padding: 0 30px 30px;
    margin-top: 15px;
    background: #fff;
    overflow: hidden;
}
.sale__item{
    margin-top: 30px;
}
.sale__item:last-child{
    border: 0;
}
.img-box{
    position: relative;
    width: 180px;
    height: 180px;
    flex-shrink: 0;
}
.img-box .tips{
    position: absolute;
    width: 60px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: #F93A42;
}
.img-box img{
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.sale__item__right{
    /* width: 480px; */
    margin-left: 30px;
}
.info-box{
    padding: 10px 30px;
    margin-top: 15px;
    background: #fff;
}
.info__item{
    height: 60px;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    padding: 0 30px;
    background: #fff;
}
.footer button{
    height: 55px;
    padding: 0 30px;
    border-radius:30px;
    margin-left: 10px;
}
.footer .hollow-btn{
    background: none;
    border: 2px solid #e6e6e6;
    font-size: 26px;
    color: #808080;
}
.footer .solid-btn{
    background: #F93A42;
    font-size: 26px;
    color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/integral/OrderDetail.vue